import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';

import { DataTableOptimizedComponent } from 'src/app/shared/data-table-optimized/data-table-optimized.component';
import { MatDividerModule } from '@angular/material/divider';
import { ArianeNavComponent } from 'src/app/layout/ariane-nav/ariane-nav.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BehaviorSubject, debounceTime, distinctUntilChanged, map, Observable, Subject, takeUntil } from 'rxjs';
import { FilterGenerique } from '@models/api/requests';
import { PagedResultDTO } from '@models/shared';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ServicesFonctionnelsService } from 'src/app/core/services/services-fonctionnels.service';
import { EditServiceModalComponent } from './edit-service-modal/edit-service-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-gestion-services',
    imports: [
    MatIconModule,
    ArianeNavComponent,
    MatDividerModule,
    DataTableOptimizedComponent,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule
],
    templateUrl: './gestion-services.component.html',
    styleUrls: ['./gestion-services.component.scss']
})
export class GestionServicesComponent implements OnInit {
  @ViewChild('administrationTable') administrationTable!: DataTableOptimizedComponent;

  arianeLabel: string = 'Services';
  arianeIcon: string = 'view_list';
  arianeList = [
    {
      label: 'Administration',
      url: '/pama/administration'
    },
    {
      label: 'Gestion des services',
      url: '/pama/administration/gestion-services'
    }
  ];

  demandesDisplayedColumns: string[] = [
    'Service',
    'Direction',
    'Responsable',
    'Destinataire RH recrutement',
    'Destinataire RH renouvellement',
    'Actions'
  ];

  demandesCellStyleCss: any = {
    //  Libellé: { 'text-align': 'center' },
    // Direction: { 'text-align': 'center' },
    // Responsable: { 'text-align': 'center' }
  };

  filterSubject = new BehaviorSubject<FilterGenerique | null>({
    filterGenerique: null
  });
  length: number;
  untransformedData: any = [];
  dataTable: any[] = [];
  dataJSON: any[] = [];
  totalRecords_postes: number = 0;
  rowData: any[] = [];
  filterGenerique = new FormControl();
  private readonly destroy$ = new Subject<void>();
  constructor(
    private readonly detectorRef: ChangeDetectorRef,
    private readonly servicesFonctionnelsService: ServicesFonctionnelsService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.filterGenerique.valueChanges.pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.destroy$)).subscribe((value) => {
      this.filterSubject.next({
        filterGenerique: value
      });
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.filterSubject.complete();
  }

  loadListServices = (pageIndex: number, pageSize: number, filter?: FilterGenerique): Observable<PagedResultDTO<any>> => {
    return this.servicesFonctionnelsService.getListOfServices(pageIndex, pageSize, filter).pipe(
      map((response) => {
        this.rowData = this.transformDataListeServices(response.results || []);
        this.length = response.totalRecords;
        this.detectorRef.detectChanges();
        return {
          ...response,
          results: this.transformDataListeServices(response.results || response)
        };
      })
    );
  };

  clearFilter() {
    this.filterGenerique.setValue('');
  }

  transformDataListeServices(serviceList: any[]): any {
    const transformed = serviceList.map((service) => {
      const destinataireRhRecrutement = service?.structValidationRh ?? service?.direction?.structValidationGpeec ?? '';
      const destinataireRhRenouvellement = service?.direction?.structValidationStatutaire ?? '';

      return {
        id: service?.id,
        Service: service?.libelle ?? '',
        Direction: service?.direction?.libelle ?? '',
        responsable: service?.responsable ?? null,
        Responsable: service?.responsable ? `${service.responsable.nom} ${service.responsable.prenom}` : '',
        'Destinataire RH recrutement': destinataireRhRecrutement,
        'Destinataire RH renouvellement': destinataireRhRenouvellement
      };
    });

    return transformed;
  }

  editService(event: any) {
    this.dialog
      .open(EditServiceModalComponent, {
        width: '780px',
        disableClose: true,
        data: {
          edition: true,
          id: event.id,
          service: event.Service,
          responsable: event.responsable
        }
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        console.log('result', result);

        if (result) {
          this.administrationTable?.refresh();
        }
      });
  }
}
